// /user/v1/user/attrid/bind
import { createApiMutationHook } from "@/hooks/use-api-mutation";
import { UserAttridBindReq, UserAttridBindRes } from "@/types/api/user/user-attrid-bind.d";
import { post } from "@/libs/http";

export const attridBind = ({ params }: { params: UserAttridBindReq; }) => {
  return post<UserAttridBindRes>('/user/v1/user/attrid/bind', params);
};

export const useAttridBind = createApiMutationHook(attridBind);
